import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { MAT_SORT_DEFAULT_OPTIONS } from '@angular/material/sort';

export function provideTableSort(): EnvironmentProviders {
	return makeEnvironmentProviders([
		{ provide: MAT_SORT_DEFAULT_OPTIONS, useValue: { disableClear: true } },
	]);
}
